import { objToSnake } from 'utils/general';
import { api } from './index';

export const updateLeadCustomFieldResponse = async (orgId, leadId, fieldId, urlId, field) => {
  return api.post(
    `/api/organization/${orgId}/leads/${leadId}/custom_field_response/${urlId || fieldId}`,
    { [fieldId]: objToSnake(field) },
  );
};


export const getLeadComments = (orgId, leadId) => {
  return api.get(`/api/organization/${orgId}/leads/${leadId}/comments`);
};

export const createLeadComment = async (orgId, leadId, comment, kind = 'user') => {
  return api.post(
    `/api/organization/${orgId}/leads/${leadId}/comments`,
    { body: comment, kind },
  );
};

export const updateLeadComment = (orgId, leadId, commentId, comment) => {
  return api.put(
    `/api/organization/${orgId}/leads/${leadId}/comments/comment/${commentId}`,
    { body: comment },
  );
};

export const deleteLeadComment = (orgId, leadId, commentId) => {
  return api.delete(`/api/organization/${orgId}/leads/${leadId}/comments/comment/${commentId}`);
};

export const deleteLeadContact = (orgId, leadId, contactId, type) => {
  return api.delete(`/api/organization/${orgId}/leads/${leadId}/contact/${type}/${contactId}`);
};
